<form [formGroup]="advisorForm" id="advisor-form" class="mb-3">
    <h2>¿Recibiste acompañamiento de un asesor SURA?</h2>

    <div class="radio-group">

        <label for="helped">
            <input type="radio" id="helped" name="assistance" formControlName="assistance" value="si"
                class="radio-input" />
            <span>Sí</span>
        </label>
    </div>

    <div class="radio-group ms-3">

        <label for="noHelped">
            <input type="radio" id="noHelped" name="assistance" formControlName="assistance" value="no"
                class="radio-input" />
            <span>No</span>
        </label>
    </div>

    @if(withAssistance()){

    <div class="group mt-3">
        <label class="advisor-label" for="advisorName">Ingresa el <b>nombre</b> ó <b>código</b> de tu asesor</label>
        <input type="text" id="advisorName" class="mt-2 form-control estiloPrincipal"
            placeholder="Ejemplo: José Ramírez" [formControl]="advisorControl" autocomplete="off"
            [class.invalidAdvisor]="isInvalidAdvisor()"
            />


         @if (showError()) {
            <div class="mt-1 group invalid-advisor">
                <small class="error">
                    <img src="./assets/img/error-circle.svg" alt="error" />
                    {{ showErrorMessage() }}
                </small>
            </div>
        } 
    


        @if(filteredAdvisors.length > 0){
        <ul class="dropdown">
            @for (asesor of filteredAdvisors; track asesor['Cod']) {
            <li class="dropdown-item" (click)="selectAdvisor(asesor)">
               <p> {{ asesor['Nombre-cod'] }} </p>
            </li>
            }
        </ul>
        }



    </div>

    }

</form>